export const GET_USERS = 'user/get_users';
export const GET_USERS_COMPLETED = 'user/get_users_COMPLETED';
export const GET_USERS_FAILED = 'user/get_users_failed';
